import { FC } from 'react';

interface SortTriangleIconProps {
  color?: string;
  className?: string;
  width?: string;
  height?: string;
  reverse?: boolean;
}

export const SortTriangleIcon: FC<SortTriangleIconProps> = ({
  color = 'currentColor',
  width = '8',
  height = '5',
  className,
  reverse,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 8 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={{ transform: reverse ? 'rotate(180deg)' : '' }}
    {...props}
  >
    <path
      d="M3.2339 0.244078L0.245748 3.23223C-0.279222 3.7572 0.0925833 4.65482 0.835004 4.65482H6.81132C7.55374 4.65482 7.92554 3.7572 7.40057 3.23223L4.41242 0.244078C4.08698 -0.0813592 3.55934 -0.0813592 3.2339 0.244078Z"
      transform="translate(0.176 0.213)"
      fill={color}
    />
  </svg>
);
